import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
} from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import useWizardStore from '@zs/useWizardStore';
import * as common from '@/common';
import * as elements from '@svg/elements';
import {
  octSettings,
} from '@/imageFiles';
import cache from '@/cache';
import {
  Coord,
} from '@t/LayoutTypes';


export function useOctViewer(
  eye: 'OD' | 'OS',
) {
  const [bSlice, setBSlice] = useState(0);
  const [bIndex, setBIndex] = useState(0);

  const handleBSlice = useCallback((value: number) => {
    setBSlice(value);
  }, []);

  const handleBScroll = useCallback((ev: React.ChangeEvent<HTMLInputElement>) => {
    setBIndex(Number(ev.target.value) - 1);
  }, []);

  const enfaceMemo = useMemo(() => {
    return elements.getEnfaceDeg(bSlice, bIndex);
  }, [bIndex, bSlice]);

  return {
    slice: { bSlice, setBSlice, handleBSlice },
    index: { bIndex, setBIndex, handleBScroll },
    enface: enfaceMemo,
  };
}
